import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { eventsActions } from "../../../_store/events.slice";
import CommonModal from "../../../components/common/ui/NotificationModal/CommonModal";
import { Modal } from "bootstrap";
import ICS from "../../../assets/ics.png";
import {
  addEventToGoogleCalendar,
  exportEventAsICS,
} from "../../../_helpers/googleCalendarUtils";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";

function CalenderInMainPage() {
  const dispatch = useDispatch();
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [clickedDate, setClickedDate] = useState("");
  const [visibleEventsByDate, setVisibleEventsByDate] = useState({});
  const [hiddenEventsByDate, setHiddenEventsByDate] = useState({});
  const [currentMonth, setCurrentMonth] = useState(new Date()?.getMonth() + 1);
  const [currentYear, setCurrentYear] = useState(new Date()?.getFullYear());
  const UserRole = sessionStorage.getItem("userRoleID");
  const { getEventListForCalenderResponse } = useSelector((x) => x?.events);
  const calendarRef = useRef();
  // Retrieve the stored committee ID(s) from sessionStorage
  // const committees = JSON.parse(sessionStorage.getItem("committee_Id"));
  // console.log("committees", committees);

  // let committees;
  // const storedCommittees = sessionStorage.getItem("committee_Id");

  // if (storedCommittees && storedCommittees !== "undefined") {
  //   committees = JSON?.parse(storedCommittees);
  // } else {
  //   committees = []; // or null, depending on your use case
  // }
  const [confirmOpenIndex, setConfirmOpenIndex] = useState(null);

  useEffect(() => {
    dispatch(
      eventsActions?.getEventListForCalender({
        month: currentMonth,
        year: currentYear,
      }),
    );
  }, [currentMonth, currentYear]);

  useEffect(() => {
    if (calendarRef.current) {
      // Full rerender won't happen, but UI will update
      calendarRef.current.getApi().render();
    }
  }, [visibleEventsByDate]);

  useEffect(() => {
    const rawEvents = getEventListForCalenderResponse?.data?.events || [];
    const events = rawEvents.map((event) => event);
    const grouped = {};

    events.forEach((event) => {
      const dateKey = new Date(event.start).toISOString().split("T")[0];
      if (!grouped[dateKey]) grouped[dateKey] = [];
      grouped[dateKey].push(event);
    });

    // Limit to first 3 and collect the rest
    const visible = {};
    const hidden = {};

    for (const date in grouped) {
      visible[date] = grouped[date].slice(0, 3);
      if (grouped[date].length > 3) {
        hidden[date] = grouped[date].length - 3;
      }
    }

    setVisibleEventsByDate(visible);
    setHiddenEventsByDate(hidden);
  }, [getEventListForCalenderResponse?.data?.events]);

  // const formatDateForGoogleCalendar = (isoDate) => {
  //   return new Date(isoDate)
  //     .toISOString()
  //     .replace(/[-:]/g, "") // remove dashes and colons
  //     .replace(".000", ""); // remove milliseconds
  // };

  // NEW
  // const formatDateForGoogleCalendar = (dateString) => {
  //   const localDate = new Date(dateString);
  //   const pad = (num) => String(num).padStart(2, "0");
  //   return (
  //     localDate.getFullYear() +
  //     pad(localDate.getMonth() + 1) +
  //     pad(localDate.getDate()) +
  //     "T" +
  //     pad(localDate.getHours()) +
  //     pad(localDate.getMinutes()) +
  //     pad(localDate.getSeconds())
  //   );
  // };

  // function formatICSDescription(text = "") {
  //   return text
  //     .replace(/\r\n|\r|\n/g, "\\n") // normalize all newlines
  //     .replace(/(.{1,75})/g, "$1\r\n "); // fold lines (space at start!)
  // }

  //   const handleExportICSForSingleEvent = (e, event) => {
  //     e.preventDefault();
  //     const eventType = event?.location;
  //     const description =
  //       eventType === "hybrid"
  //         ? `${event.description}\n\nJoin link: ${event.url}`
  //         : event.description;
  //     // Build the ICS content
  //     const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Event Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(event.start)}
  // DTEND:${formatDate(event.end)}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${eventType === "virtual" ? event?.url : event?.address}
  // END:VEVENT
  // END:VCALENDAR
  // `.trim();

  //     // Create a Blob
  //     const blob = new Blob([icsContent], {
  //       type: "text/calendar;charset=utf-8",
  //     });

  //     // Create a download link
  //     const link = document.createElement("a");
  //     link.href = URL.createObjectURL(blob);
  //     link.download = `${event.title || "event"}.ics`;
  //     link.click();
  //   };

  //   const handleExportICS = (e, event) => {
  //     e.preventDefault();
  //     debugger;
  //     const eventType = event?.eventType;
  //     if (eventType === "single") {
  //       handleExportICSForSingleEvent(e, event);
  //     }
  //     const recurrence = event?.recurrenceId;
  //     // ---------- Helpers ----------
  //     const formatDate = (date) => {
  //       const d = new Date(date);
  //       return d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  //     };
  //     const formatICSDescription = (text) => (text || "").replace(/\n/g, "\\n");
  //     const dayMap = {
  //       sunday: "SU",
  //       monday: "MO",
  //       tuesday: "TU",
  //       wednesday: "WE",
  //       thursday: "TH",
  //       friday: "FR",
  //       saturday: "SA",
  //     };
  //     const getBYDAY = (days = []) =>
  //       days.map((d) => dayMap[d.toLowerCase()]).join(",");
  //     const getDayIndex = (day) =>
  //       [
  //         "sunday",
  //         "monday",
  //         "tuesday",
  //         "wednesday",
  //         "thursday",
  //         "friday",
  //         "saturday",
  //       ].indexOf(day.toLowerCase());
  //     // ---------- Common ----------
  //     const description =
  //       event.location === "hybrid"
  //         ? `${event.description}\n\nJoin link: ${event.url}`
  //         : event.description;

  //     const duration =
  //       new Date(event.end).getTime() - new Date(event.start).getTime();

  //     // =========================================================
  //     //  CASE 1: Use explicit dates
  //     // =========================================================
  //     if (recurrence?.datesSelected?.length > 0) {
  //       let vevents = "";

  //       recurrence.datesSelected.forEach((date) => {
  //         const startDate = new Date(date);
  //         const endDate = new Date(startDate.getTime() + duration);

  //         vevents += `
  // BEGIN:VEVENT
  // UID:${startDate.getTime()}@yourapp.com
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(startDate)}
  // DTEND:${formatDate(endDate)}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // END:VEVENT`;
  //       });

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // ${vevents}
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }

  //     // =========================================================
  //     //  CASE 2: WEEKLY RRULE
  //     // =========================================================
  //     if (recurrence?.period === "week") {
  //       const repeatEvery = recurrence.repeatEvery || 1;
  //       const days = recurrence.weekDaySelected || [];

  //       const getAdjustedStart = () => {
  //         let dt = new Date(recurrence.start);

  //         while (!days.some((d) => dt.getDay() === getDayIndex(d))) {
  //           dt.setDate(dt.getDate() + 1);
  //         }

  //         return dt;
  //       };

  //       const adjustedStart = getAdjustedStart();

  //       const rrule = `RRULE:FREQ=WEEKLY;INTERVAL=${repeatEvery};BYDAY=${getBYDAY(
  //         days,
  //       )};UNTIL=${formatDate(recurrence.end)}`;

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // UID:${Date.now()}@yourapp.com
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(adjustedStart)}
  // DTEND:${formatDate(new Date(adjustedStart.getTime() + duration))}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // ${rrule}
  // END:VEVENT
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }

  //     // =========================================================
  //     //  CASE 3: MONTHLY RRULE
  //     // =========================================================
  //     if (recurrence?.period === "month") {
  //       const repeatEvery = recurrence.repeatEvery || 1;
  //       const days = recurrence.monthDaySelected || [];

  //       const hasMultipleDays = days.length > 1;

  //       // ⚠️ Multiple weekdays → fallback needed
  //       if (hasMultipleDays) {
  //         console.warn("Monthly multi-day → use datesSelected instead");
  //         return;
  //       }

  //       const byDay = getBYDAY(days);

  //       const freqMap = {
  //         1: 1, // first week
  //         2: 2,
  //         3: 3,
  //         4: 4,
  //         5: -1, // last week
  //       };

  //       const bySetPos = freqMap[recurrence.monthFrequency];

  //       const adjustedStart = new Date(event.start);

  //       const rrule = `RRULE:FREQ=MONTHLY;INTERVAL=${repeatEvery};BYDAY=${byDay};BYSETPOS=${bySetPos};UNTIL=${formatDate(recurrence.end)}`;

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // UID:${Date.now()}@yourapp.com
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(adjustedStart)}
  // DTEND:${formatDate(new Date(adjustedStart.getTime() + duration))}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // ${rrule}
  // END:VEVENT
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }

  //     // =========================================================
  //     //  CASE 4: DAILY RRULE
  //     // =========================================================
  //     if (recurrence?.period === "day") {
  //       const repeatEvery = recurrence.repeatEvery || 1;

  //       const adjustedStart = new Date(recurrence.start);

  //       const rrule = `RRULE:FREQ=DAILY;INTERVAL=${repeatEvery};UNTIL=${formatDate(
  //         recurrence.end,
  //       )}`;

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // UID:${Date.now()}@yourapp.com
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(adjustedStart)}
  // DTEND:${formatDate(new Date(adjustedStart.getTime() + duration))}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // ${rrule}
  // END:VEVENT
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }

  //     // =========================================================
  //     //  CASE 5: YEARLY RRULE
  //     // =========================================================
  //     if (recurrence?.period === "year") {
  //       const repeatEvery = recurrence.repeatEvery || 1;

  //       const adjustedStart = new Date(recurrence.start);

  //       const rrule = `RRULE:FREQ=YEARLY;INTERVAL=${repeatEvery};UNTIL=${formatDate(
  //         recurrence.end,
  //       )}`;

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // UID:${Date.now()}@yourapp.com
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(adjustedStart)}
  // DTEND:${formatDate(new Date(adjustedStart.getTime() + duration))}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // ${rrule}
  // END:VEVENT
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }
  //   };

  // ---------- Download helper ----------

  //   const handleExportICS = (e, event) => {
  //     e.preventDefault();
  //     debugger;
  //     const eventType = event?.eventType;
  //     if (eventType === "single") {
  //       handleExportICSForSingleEvent(e, event);
  //     }
  //     const recurrence = event?.recurrenceId;
  //     // ---------- Helpers ----------
  //     const formatDate = (date) => {
  //       const d = new Date(date);
  //       return d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  //     };
  //     const formatICSDescription = (text) => (text || "").replace(/\n/g, "\\n");
  //     const dayMap = {
  //       sunday: "SU",
  //       monday: "MO",
  //       tuesday: "TU",
  //       wednesday: "WE",
  //       thursday: "TH",
  //       friday: "FR",
  //       saturday: "SA",
  //     };
  //     const getBYDAY = (days = []) =>
  //       days.map((d) => dayMap[d.toLowerCase()]).join(",");
  //     const getDayIndex = (day) =>
  //       [
  //         "sunday",
  //         "monday",
  //         "tuesday",
  //         "wednesday",
  //         "thursday",
  //         "friday",
  //         "saturday",
  //       ].indexOf(day.toLowerCase());
  //     // ---------- Common ----------
  //     const description =
  //       event.location === "hybrid"
  //         ? `${event.description}\n\nJoin link: ${event.url}`
  //         : event.description;

  //     const duration =
  //       new Date(event.end).getTime() - new Date(event.start).getTime();

  //     // =========================================================
  //     //  CASE 1: Use explicit dates
  //     // =========================================================
  //     //     if (recurrence?.datesSelected?.length > 0) {
  //     //       let vevents = "";

  //     //       recurrence.datesSelected.forEach((date) => {
  //     //         const startDate = new Date(date);
  //     //         const endDate = new Date(startDate.getTime() + duration);

  //     //         vevents += `
  //     // BEGIN:VEVENT
  //     // UID:${startDate.getTime()}@yourapp.com
  //     // SUMMARY:${event.title}
  //     // DTSTART:${formatDate(startDate)}
  //     // DTEND:${formatDate(endDate)}
  //     // DESCRIPTION:${formatICSDescription(description)}
  //     // URL:${event.url || ""}
  //     // LOCATION:${event.location === "virtual" ? event.url : event.address}
  //     // END:VEVENT`;
  //     //       });

  //     //       const icsContent = `
  //     // BEGIN:VCALENDAR
  //     // VERSION:2.0
  //     // PRODID:-//YourApp//Universal Export//EN
  //     // CALSCALE:GREGORIAN
  //     // ${vevents}
  //     // END:VCALENDAR`.trim();

  //     //       downloadICS(icsContent, event.title);
  //     //       return;
  //     //     }
  //     // CASE 1: Use explicit dates ONLY for custom date selection

  //     if (
  //       recurrence?.datesSelected?.length > 0 &&
  //       !["day", "week", "month", "year"].includes(recurrence?.period)
  //     ) {
  //       let vevents = "";

  //       recurrence.datesSelected.forEach((date) => {
  //         const startDate = new Date(date);
  //         const endDate = new Date(startDate.getTime() + duration);

  //         vevents += `
  // BEGIN:VEVENT
  // UID:${startDate.getTime()}@yourapp.com0
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(startDate)}
  // DTEND:${formatDate(endDate)}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // END:VEVENT`;
  //       });

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // ${vevents}
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }
  //     // =========================================================
  //     //  CASE 2: WEEKLY RRULE
  //     // =========================================================
  //     if (recurrence?.period === "week") {
  //       const repeatEvery = recurrence.repeatEvery || 1;
  //       const days = recurrence.weekDaySelected || [];

  //       const getAdjustedStart = () => {
  //         let dt = new Date(recurrence.start);

  //         while (!days.some((d) => dt.getDay() === getDayIndex(d))) {
  //           dt.setDate(dt.getDate() + 1);
  //         }

  //         return dt;
  //       };

  //       const adjustedStart = getAdjustedStart();

  //       const rrule = `RRULE:FREQ=WEEKLY;INTERVAL=${repeatEvery};BYDAY=${getBYDAY(
  //         days,
  //       )};UNTIL=${formatDate(recurrence.end)}`;

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // UID:${recurrence._id}@yourapp.com
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(adjustedStart)}
  // DTEND:${formatDate(new Date(adjustedStart.getTime() + duration))}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // ${rrule}
  // END:VEVENT
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }

  //     // =========================================================
  //     //  CASE 3: MONTHLY RRULE
  //     // =========================================================
  //     if (recurrence?.period === "month") {
  //       const repeatEvery = recurrence.repeatEvery || 1;
  //       const days = recurrence.monthDaySelected || [];

  //       const hasMultipleDays = days.length > 1;

  //       // ⚠️ Multiple weekdays → fallback needed
  //       if (hasMultipleDays) {
  //         console.warn("Monthly multi-day → use datesSelected instead");
  //         return;
  //       }

  //       const byDay = getBYDAY(days);

  //       const freqMap = {
  //         1: 1, // first week
  //         2: 2,
  //         3: 3,
  //         4: 4,
  //         5: -1, // last week
  //       };

  //       const bySetPos = freqMap[recurrence.monthFrequency];

  //       const adjustedStart = new Date(event.start);

  //       const rrule = `RRULE:FREQ=MONTHLY;INTERVAL=${repeatEvery};BYDAY=${byDay};BYSETPOS=${bySetPos};UNTIL=${formatDate(recurrence.end)}`;

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // UID:${recurrence._id}@yourapp.com
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(adjustedStart)}
  // DTEND:${formatDate(new Date(adjustedStart.getTime() + duration))}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // ${rrule}
  // END:VEVENT
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }

  //     // =========================================================
  //     //  CASE 4: DAILY RRULE
  //     // =========================================================
  //     if (recurrence?.period === "day") {
  //       const repeatEvery = recurrence.repeatEvery || 1;

  //       const adjustedStart = new Date(recurrence.start);

  //       const rrule = `RRULE:FREQ=DAILY;INTERVAL=${repeatEvery};UNTIL=${formatDate(
  //         recurrence.end,
  //       )}`;

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // UID:${recurrence._id}@yourapp.com
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(adjustedStart)}
  // DTEND:${formatDate(new Date(adjustedStart.getTime() + duration))}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // ${rrule}
  // END:VEVENT
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }

  //     // =========================================================
  //     //  CASE 5: YEARLY RRULE
  //     // =========================================================
  //     if (recurrence?.period === "year") {
  //       const repeatEvery = recurrence.repeatEvery || 1;

  //       const adjustedStart = new Date(recurrence.start);

  //       const rrule = `RRULE:FREQ=YEARLY;INTERVAL=${repeatEvery};UNTIL=${formatDate(
  //         recurrence.end,
  //       )}`;

  //       const icsContent = `
  // BEGIN:VCALENDAR
  // VERSION:2.0
  // PRODID:-//YourApp//Universal Export//EN
  // CALSCALE:GREGORIAN
  // BEGIN:VEVENT
  // UID:${recurrence._id}@yourapp.com
  // SUMMARY:${event.title}
  // DTSTART:${formatDate(adjustedStart)}
  // DTEND:${formatDate(new Date(adjustedStart.getTime() + duration))}
  // DESCRIPTION:${formatICSDescription(description)}
  // URL:${event.url || ""}
  // LOCATION:${event.location === "virtual" ? event.url : event.address}
  // ${rrule}
  // END:VEVENT
  // END:VCALENDAR`.trim();

  //       downloadICS(icsContent, event.title);
  //       return;
  //     }
  //   };

  // function downloadICS(content, title) {
  //   const blob = new Blob([content], {
  //     type: "text/calendar;charset=utf-8",
  //   });

  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.download = `${title || "event"}.ics`;
  //   link.click();
  // }
  // const formatDate = (date) => {
  //   return (
  //     new Date(date).toISOString().replace(/[-:]/g, "").split(".")[0] + "Z"
  //   );
  // };

  // const findDateRange = useCallback((startDate, endDate) => {
  //   debugger;
  //   const start = new Date(startDate);
  //   const end = new Date(endDate);
  //   start.setUTCHours(0, 0, 0, 0);
  //   end.setUTCHours(0, 0, 0, 0);
  //   const diffDays = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;
  //   return diffDays;
  // }, []);

  // const dayMap = {
  //   sunday: "SU",
  //   monday: "MO",
  //   tuesday: "TU",
  //   wednesday: "WE",
  //   thursday: "TH",
  //   friday: "FR",
  //   saturday: "SA",
  // };

  // const getRecurranceEventURL = (event) => {
  //   const byDay = event?.recurrenceId?.weekDaySelected
  //     ?.map((day) => dayMap[day.toLowerCase()])
  //     ?.join(",");
  //   const byDayForMonthWise = event?.recurrenceId?.monthDaySelected
  //     ?.map((day) => dayMap[day.toLowerCase()])
  //     ?.join(",");

  //   const count = findDateRange(
  //     event?.recurrenceId?.start,
  //     event?.recurrenceId?.end,
  //   );
  //   console.log("freq", event?.recurrenceId?.monthFrequency);
  //   switch (event?.recurrenceId?.period) {
  //     case "day":
  //       return `RRULE:FREQ=DAILY;INTERVAL=${event?.recurrenceId?.repeatEvery};UNTIL=${formatDateForGoogleCalendar(event?.recurrenceId?.end)}`;

  //     case null: //same as day
  //       return `RRULE:FREQ=DAILY;INTERVAL=${event?.recurrenceId?.repeatEvery};UNTIL=${formatDateForGoogleCalendar(event?.recurrenceId?.end)}`;

  //     case "week":
  //       return `RRULE:FREQ=WEEKLY;INTERVAL=${event?.recurrenceId?.repeatEvery};BYDAY=${byDay};UNTIL=${formatDateForGoogleCalendar(event?.recurrenceId?.end)}`;

  //     case "month":
  //       // return `RRULE:FREQ=MONTHLY;BYDAY=MO;BYSETPOS=1;UNTIL=${formatDateForGoogleCalendar(event?.recurrenceId?.end)}`;
  //       return `RRULE:FREQ=MONTHLY;INTERVAL=${event?.recurrenceId?.repeatEvery};BYDAY=${byDayForMonthWise};BYSETPOS=${event?.recurrenceId?.monthFrequency};UNTIL=${formatDateForGoogleCalendar(event?.recurrenceId?.end)}`;
  //     case "year":
  //       return `RRULE:FREQ=YEARLY;INTERVAL=${event?.recurrenceId?.repeatEvery};UNTIL=${formatDateForGoogleCalendar(event?.recurrenceId?.end)}`;

  //     default:
  //       break;
  //   }
  // };

  // const getGoogleCalendarDatesAndRecur = (event) => {
  //   const recurrence = event?.recurrenceId;
  //   const duration =
  //     new Date(event.end).getTime() - new Date(event.start).getTime();

  //   const dayMap = {
  //     sunday: "SU",
  //     monday: "MO",
  //     tuesday: "TU",
  //     wednesday: "WE",
  //     thursday: "TH",
  //     friday: "FR",
  //     saturday: "SA",
  //   };
  //   const getBYDAY = (days = []) =>
  //     days.map((d) => dayMap[d.toLowerCase()]).join(",");
  //   const getDayIndex = (day) =>
  //     [
  //       "sunday",
  //       "monday",
  //       "tuesday",
  //       "wednesday",
  //       "thursday",
  //       "friday",
  //       "saturday",
  //     ].indexOf(day.toLowerCase());

  //   // Not a recurring event → use start/end as-is
  //   if (event?.eventType !== "recurrence" || !recurrence) {
  //     return { start: event?.start, end: event?.end, recur: null };
  //   }

  //   // Custom explicit dates (not day/week/month/year) →
  //   // Google's template URL can't hold multiple arbitrary dates,
  //   // so we show only the first occurrence.
  //   if (
  //     recurrence?.datesSelected?.length > 0 &&
  //     !["day", "week", "month", "year"].includes(recurrence?.period)
  //   ) {
  //     const firstDate = new Date(recurrence.datesSelected[0]);
  //     return {
  //       start: firstDate,
  //       end: new Date(firstDate.getTime() + duration),
  //       recur: null,
  //       isPartialOnly: true,
  //     };
  //   }

  //   // Weekly
  //   if (recurrence?.period === "week") {
  //     const repeatEvery = recurrence.repeatEvery || 1;
  //     const days = recurrence.weekDaySelected || [];
  //     let dt = new Date(recurrence.start);
  //     while (!days.some((d) => dt.getDay() === getDayIndex(d))) {
  //       dt.setDate(dt.getDate() + 1);
  //     }
  //     return {
  //       start: dt,
  //       end: new Date(dt.getTime() + duration),
  //       recur: `RRULE:FREQ=WEEKLY;INTERVAL=${repeatEvery};BYDAY=${getBYDAY(
  //         days,
  //       )};UNTIL=${formatDate(recurrence.end)}`,
  //     };
  //   }

  //   // Monthly
  //   if (recurrence?.period === "month") {
  //     const repeatEvery = recurrence.repeatEvery || 1;
  //     const days = recurrence.monthDaySelected || [];
  //     if (days.length > 1) {
  //       // multi-weekday monthly recurrence isn't expressible in one RRULE here
  //       return {
  //         start: event?.start,
  //         end: event?.end,
  //         recur: null,
  //         isPartialOnly: true,
  //       };
  //     }
  //     const freqMap = { 1: 1, 2: 2, 3: 3, 4: 4, 5: -1 };
  //     const start = new Date(event.start);
  //     return {
  //       start,
  //       end: new Date(start.getTime() + duration),
  //       recur: `RRULE:FREQ=MONTHLY;INTERVAL=${repeatEvery};BYDAY=${getBYDAY(
  //         days,
  //       )};BYSETPOS=${freqMap[recurrence.monthFrequency]};UNTIL=${formatDate(
  //         recurrence.end,
  //       )}`,
  //     };
  //   }

  //   // Daily
  //   if (recurrence?.period === "day") {
  //     const repeatEvery = recurrence.repeatEvery || 1;
  //     const start = new Date(recurrence.start);
  //     return {
  //       start,
  //       end: new Date(start.getTime() + duration),
  //       recur: `RRULE:FREQ=DAILY;INTERVAL=${repeatEvery};UNTIL=${formatDate(
  //         recurrence.end,
  //       )}`,
  //     };
  //   }

  //   // Yearly
  //   if (recurrence?.period === "year") {
  //     const repeatEvery = recurrence.repeatEvery || 1;
  //     const start = new Date(recurrence.start);
  //     return {
  //       start,
  //       end: new Date(start.getTime() + duration),
  //       recur: `RRULE:FREQ=YEARLY;INTERVAL=${repeatEvery};UNTIL=${formatDate(
  //         recurrence.end,
  //       )}`,
  //     };
  //   }

  //   return { start: event?.start, end: event?.end, recur: null };
  // };

  // const buildGoogleCalendarUrl = (event) => {
  //   const { start, end, recur } = getGoogleCalendarDatesAndRecur(event);

  //   const params = new URLSearchParams();
  //   params.set("action", "TEMPLATE");
  //   params.set("text", event?.title || "");
  //   params.set(
  //     "dates",
  //     `${formatDateForGoogleCalendar(start)}/${formatDateForGoogleCalendar(end)}`,
  //   );
  //   params.set(
  //     "location",
  //     event?.location === "virtual" ? event?.url || "" : event?.address || "",
  //   );
  //   params.set(
  //     "details",
  //     event?.location === "hybrid"
  //       ? `${event?.description || ""}\n\nJoin link: ${event?.url || ""}`
  //       : event?.description || "",
  //   );
  //   params.set("sf", "true");
  //   params.set("output", "xml");
  //   if (recur) params.set("recur", recur);

  //   return `https://calendar.google.com/calendar/render?${params.toString()}`;
  // };

  useEffect(() => {
    if (confirmOpenIndex === null) return;

    const handleClickOutside = (e) => {
      if (
        !e.target.closest(".gcal-popover") &&
        !e.target.closest(".join-btn")
      ) {
        setConfirmOpenIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [confirmOpenIndex]);

  const handleGoogleCalendarClick = (index) => {
    setConfirmOpenIndex(index === confirmOpenIndex ? null : index);
  };

  const handleConfirmYes = (event) => {
    addEventToGoogleCalendar(event, {
      // onSuccess: () => alert("Event added to your Google Calendar!"),
      onSuccess: () => {
        showToastNotification(
          "Event added to your Google Calendar!",
          "success",
        );
      },
      onError: (err) => {
        console.error("Google Calendar insert error:", err);
        //alert(err.message || "Failed to add event to Google Calendar.");
        showToastNotification(
          "Failed to add event to Google Calendar.",
          "error",
        );
      },
    });
    setConfirmOpenIndex(null);
  };

  const handleConfirmCancel = () => {
    setConfirmOpenIndex(null);
  };

  return (
    <>
      <section className="calendar" id="bcsp-calendar">
        <div className="container">
          <div className="row bg-ligh-purple border-radius-40">
            <div className="col-lg-12">
              <h1 className="main-title mb-4">Broward Partnerships for Kids</h1>
              <FullCalendar
                height="auto"
                ref={calendarRef}
                dayCellClassNames={(arg) => {
                  const dateKey = arg.date.toLocaleDateString("en-CA");
                  return visibleEventsByDate[dateKey]?.length > 0
                    ? ["fc-event-highlight"]
                    : [];
                }}
                datesSet={(arg) => {
                  const currentMonth = arg.view.currentStart.getMonth() + 1;
                  const currentYear = arg.view.currentStart.getFullYear();
                  setCurrentMonth(currentMonth);
                  setCurrentYear(currentYear);
                }}
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                headerToolbar={{
                  left: "prev,next today",
                  center: "title",
                  right: "dayGridMonth,timeGridWeek,timeGridDay",
                }}
                buttonText={{
                  today: "Today",
                  month: "Month",
                  week: "Week",
                  day: "Day",
                }}
                allDayText="All Day"
                eventClick={(info) => {
                  info.jsEvent.preventDefault(); // just in case a top-level url sneaks in

                  const ev = info.event;
                  const xp = ev.extendedProps || {};

                  // Base selection from what's inside the calendar
                  let selected = {
                    _id: xp._id || ev.id,
                    title: ev.title,
                    start: ev.start,
                    end: ev.end,
                    committee: xp.committee,
                    description: xp.description,
                    location: xp.location,
                    status: xp.status,
                    url: xp.url,
                    address: xp.address,
                    eventType: xp.eventType, // 👈 Add this
                  };

                  // 🛟 Fallback: if anything critical is missing, pull the original event from your API list
                  if (
                    !selected.url ||
                    !selected.address ||
                    !selected.description
                  ) {
                    const original =
                      getEventListForCalenderResponse?.data?.events?.find(
                        (e) => String(e._id ?? e.id) === String(ev.id),
                      );
                    if (original) {
                      selected = {
                        ...selected,
                        // prefer already-present values, otherwise fill from original
                        committee: selected.committee ?? original.committee,
                        description:
                          selected.description ?? original.description,
                        location: selected.location ?? original.location,
                        status: selected.status ?? original.status,
                        url:
                          selected.url ??
                          original.url ??
                          original.extendedProps?.url,
                        address:
                          selected.address ??
                          original.address ??
                          original.extendedProps?.address,
                        recurrenceId: original?.recurrenceId,
                      };
                    }
                  }

                  setSelectedEvents([selected]);

                  const modalElement = document.getElementById(
                    "bcsp-event-calneder-modal",
                  );
                  const modalInstance =
                    Modal.getInstance(modalElement) || new Modal(modalElement);
                  modalInstance.show();
                }}
                dateClick={(info) => {
                  const clickedDate = info.dateStr;
                  setClickedDate(clickedDate);

                  const matchedEvents =
                    getEventListForCalenderResponse?.data?.events?.filter(
                      (event) => {
                        const eventDate = new Date(event.start)
                          .toISOString()
                          .split("T")[0];
                        return eventDate === clickedDate;
                      },
                    );

                  if (matchedEvents?.length > 0) {
                    setSelectedEvents(matchedEvents);

                    const modalElement = document.getElementById(
                      "bcsp-event-calneder-modal",
                    );
                    const modalInstance =
                      Modal.getInstance(modalElement) ||
                      new Modal(modalElement);
                    modalInstance.show();
                  }
                }}
                events={getEventListForCalenderResponse?.data?.events?.map(
                  (e) => ({
                    id: String(e._id ?? e.id),
                    title: e.title ?? "",
                    start: e.start,
                    end: e.end,
                    extendedProps: {
                      committee: e.committee ?? null,
                      description: e.description ?? "",
                      location: e.location ?? "",
                      status: e.status ?? "",
                      url: e.url ?? e.extendedProps?.url ?? "",
                      address: e.address ?? e.extendedProps?.address ?? "",
                      eventType: e.eventType ?? "", // 👈 ADD THIS
                    },
                  }),
                )}
                dayMaxEventRows={4}
                moreLinkContent={(args) => (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    +{args.num} more
                  </span>
                )}
                moreLinkClick={(args) => {
                  const clickedDate = args.date.toISOString().split("T")[0];

                  // find all events for that date
                  const matchedEvents =
                    getEventListForCalenderResponse?.data?.events?.filter(
                      (event) => {
                        const eventDate = new Date(event.start)
                          .toISOString()
                          .split("T")[0];
                        return eventDate === clickedDate;
                      },
                    );

                  setClickedDate(clickedDate);
                  setSelectedEvents(matchedEvents);

                  const modalElement = document.getElementById(
                    "bcsp-event-calneder-modal",
                  );
                  const modalInstance =
                    Modal.getInstance(modalElement) || new Modal(modalElement);
                  modalInstance.show();

                  return "none"; // prevent FullCalendar’s built-in popover
                }}
                eventContent={(arg) => {
                  const formatTime = (dateStr) =>
                    new Date(dateStr).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    });

                  const start = formatTime(arg.event.start);
                  const end = formatTime(arg.event.end);
                  const rawTitle = arg.event.title || "";
                  const truncatedTitle =
                    rawTitle.length > 25
                      ? rawTitle.substring(0, 25) + "..."
                      : rawTitle;

                  return (
                    <div className="date-cell" title={rawTitle}>
                      <div className="calender-event-title">
                        {truncatedTitle}
                      </div>
                      <b className="calender-event-time">
                        {start} to {end}
                      </b>
                    </div>
                  );
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <CommonModal
        modalId="bcsp-event-calneder-modal"
        title="Events Details"
        modalSize="modal-lg"
        bodyContent={
          <>
            {selectedEvents?.length > 0 ? (
              <ul>
                {selectedEvents.map((event, index) => (
                  <>
                    {console.log(event)}
                    {index !== 0 && <hr />}
                    <li key={index} className="bpk-public-event-list">
                      <h3>{event?.committee?.committeeName}</h3>
                      <h4>{event.title}</h4>
                      <div className="mt-2">
                        <i className="fa fa-calendar" aria-hidden="true"></i>{" "}
                        {new Date(event.start).toLocaleString([], {
                          year: "numeric",
                          month: "2-digit",
                          day: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                        })}{" "}

                        –{" "}

                        {new Date(event.end).toLocaleString([], {
                          year: "numeric",
                          month: "2-digit",
                          day: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                        })}
                      </div>

                      {event?.address && (
                        <div className="mt-2">
                          <i
                            className="fa fa-location-arrow"
                            aria-hidden="true"
                          ></i>
                          <span className="event-address-name">
                            {" " + event?.address}
                          </span>
                        </div>
                      )}
                      <div className="d-flex mt-3 flex-wrap gap-2">
                        {event?.url && (
                          <a
                            href={event?.url}
                            target="self"
                            className="join-btn"
                            rel="noopener noreferrer"
                          >
                            <i
                              class="fa fa-video-camera"
                              aria-hidden="true"
                            ></i>
                            <div className="mx-2">Join</div>
                          </a>
                        )}


                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <button
                            type="button"
                            className="join-btn"
                            style={{ border: "none" }}
                            onClick={() => handleGoogleCalendarClick(index)}
                          >
                            <i
                              class="fa fa-calendar-plus"
                              aria-hidden="true"
                            ></i>
                            <span className="mx-2">Add to Google Calendar</span>
                          </button>

                          <div
                            className={`gcal-popover ${confirmOpenIndex === index
                              ? "gcal-popover-open"
                              : ""
                              }`}
                          >
                            <div className="gcal-popover-arrow" />
                            <div className="gcal-popover-icon">
                              <i
                                className="fa fa-calendar-plus"
                                aria-hidden="true"
                              ></i>
                              <p className="gcal-popover-text">
                                Are you sure you want to add this event to your
                                Google Calendar?
                              </p>
                            </div>
                            <div className="gcal-popover-actions">
                              <button
                                type="button"
                                className="gcal-btn-cancel"
                                onClick={handleConfirmCancel}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="gcal-btn-confirm"
                                onClick={() => handleConfirmYes(event)}
                              >
                                Yes, Add
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          {/* <Button
                            label="Export as .ics file"
                            status="reset"
                            onClick={(e) => {
                              handleExportICS(e, event);
                            }}
                          /> */}
                          <a
                            href={event?.url}
                            target="self"
                            className="join-btn cursor-pointer"
                            // onClick={(e) => {
                            //   handleExportICS(e, event);
                            // }}
                            onClick={(e) => {
                              e.preventDefault();
                              exportEventAsICS(event);
                            }}
                          >
                            <img height="20px" width="20px" src={ICS} alt="" />
                            <span className="mx-2">Export as .ics file</span>
                          </a>
                        </div>
                      </div>
                      {event?.description && (
                        <div className="mt-3">
                          <strong className="text-decoration-underline">
                            Description{" "}
                          </strong>
                          <div className="indent" style={{ textAlign: "justify" }}>{event?.description}</div>
                        </div>
                      )}

                      {/* {event?.eventType === "recurrence" && (
                        <div style={{ color: "red", marginTop: "5px" }}>
                          Since this is a recurring event, please add the series
                          manually to your calendar.
                        </div>
                      )} */}
                      {/* )} */}
                    </li>
                  </>
                ))}
              </ul>
            ) : (
              <p>No events found.</p>
            )}
          </>
        }
        footerContent={
          <button className="btn button-primary" data-bs-dismiss="modal">
            Close
          </button>
        }
      />
    </>
  );
}

export default CalenderInMainPage;
